/**
 * Spanish (Spain) Messages
 * This file contains all messages for es_ES locale
 */

export const ERROR_MESSAGES = {
  // Template related errors
  TEMPLATE: {
    FRIENDLY_NAME_REQUIRED: "Ingrese nombre amigable",
    FRIENDLY_NAME_REQUIRED_ALT: "Ingrese el nombre amigable",
    MESSAGE_REQUIRED: "El mensaje es requerido",
    MODULE_REQUIRED: "La selección del módulo es requerida",
  },

  // Form validation errors
  VALIDATION: {
    REQUIRED: "Requerido",
    PHONE_NUMBER_REQUIRED: "El número de teléfono es requerido.",
    PHONE_NUMBER_INVALID: "Por favor proporcione un número de teléfono válido.",
    NAME_REQUIRED: "Por favor proporcione un nombre.",
    EMAIL_REQUIRED: "El correo electrónico es requerido",
    EMAIL_INVALID: "Por favor proporcione una dirección de correo electrónico válida",
    ALL_FIELDS_REQUIRED: "Por favor complete todos los campos y verifique el formato de su correo electrónico",
    SAVED_VIEW_NAME_REQUIRED: "Introduzca un nombre para guardar esta vista.",
  },

  // Message related errors
  MESSAGE: {
    TO_NUMBER_REQUIRED: "¡El número de destino es requerido!",
    MESSAGE_BODY_REQUIRED: "¡El cuerpo del mensaje es requerido!",
    SEND_FAILED: "Error al enviar el mensaje",
    SEND_ERROR: "Ocurrió un error al enviar el mensaje",
  },

  // General errors
  GENERAL: {
    SOMETHING_WENT_WRONG: "¡Algo salió mal!",
    ERROR: "Error",
    UNKNOWN_ERROR: "Ocurrió un error inesperado",
  },

  // Phone/Number related errors
  PHONE: {
    NUMBER_REQUIRED: "Por favor proporcione un número de teléfono.",
    INVALID_FORMAT: "Por favor ingrese un formato de número de teléfono válido",
  },

  // User/Admin related errors
  USER: {
    INVALID_CREDENTIALS: "Credenciales inválidas",
    ACCESS_DENIED: "Acceso denegado",
    USER_NOT_FOUND: "Usuario no encontrado",
  },
};

export const SUCCESS_MESSAGES = {
  // Template related success messages
  TEMPLATE: {
    ADDED: "¡Plantilla agregada! Personalice los mensajes del cliente con facilidad.",
    UPDATED: "¡Plantilla actualizada! Su mensaje ha sido refrescado.",
    AFTER_ADDING_MESSAGE: "Simplifique su mensajería con plantillas personalizables para una comunicación eficiente.",
  },

  // Message related success messages
  MESSAGE: {
    SENT_SUCCESS: "Mensaje enviado exitosamente",
  },

  // General success messages
  GENERAL: {
    OPERATION_SUCCESS: "Operación completada exitosamente",
    SAVED: "Cambios guardados exitosamente",
    UPDATED: "Actualizado exitosamente",
    DELETED: "Eliminado exitosamente",
  },

  // User/Admin related success messages
  USER: {
    CREATED: "Usuario creado exitosamente",
    UPDATED: "Usuario actualizado exitosamente",
    DELETED: "Usuario eliminado exitosamente",
  },
};

export const CONFIRMATION_MESSAGES = {
  // Template related confirmation messages
  TEMPLATE: {
    DELETE_CONFIRMATION: "¿Eliminar esta plantilla? Podría seguir siendo utilizada en automatizaciones o campañas.",
  },

  // General confirmation messages
  GENERAL: {
    DELETE_CONFIRMATION: "¿Está seguro de que desea eliminar este elemento?",
    SAVE_CONFIRMATION: "¿Desea guardar sus cambios?",
    CANCEL_CONFIRMATION: "¿Está seguro de que desea cancelar? Sus cambios se perderán.",
  },
};

// Helper function to get error message by key path
export const getErrorMessage = (keyPath) => {
  const keys = keyPath.split('.');
  let message = ERROR_MESSAGES;
  
  for (const key of keys) {
    if (message && message[key]) {
      message = message[key];
    } else {
      console.warn(`Error message not found for key path: ${keyPath}`);
      return ERROR_MESSAGES.GENERAL.UNKNOWN_ERROR;
    }
  }
  
  return message;
};

// Helper function to get success message by key path
export const getSuccessMessage = (keyPath) => {
  const keys = keyPath.split('.');
  let message = SUCCESS_MESSAGES;
  
  for (const key of keys) {
    if (message && message[key]) {
      message = message[key];
    } else {
      console.warn(`Success message not found for key path: ${keyPath}`);
      return SUCCESS_MESSAGES.GENERAL.OPERATION_SUCCESS;
    }
  }
  
  return message;
};

// Helper function to get confirmation message by key path
export const getConfirmationMessage = (keyPath) => {
  const keys = keyPath.split('.');
  let message = CONFIRMATION_MESSAGES;
  
  for (const key of keys) {
    if (message && message[key]) {
      message = message[key];
    } else {
      console.warn(`Confirmation message not found for key path: ${keyPath}`);
      return CONFIRMATION_MESSAGES.GENERAL.DELETE_CONFIRMATION;
    }
  }
  
  return message;
};

// Export individual message categories for direct import
export const {
  TEMPLATE: TEMPLATE_ERRORS,
  VALIDATION,
  MESSAGE: MESSAGE_ERRORS,
  GENERAL: GENERAL_ERRORS,
  PHONE,
  USER: USER_ERRORS,
} = ERROR_MESSAGES;

export const {
  TEMPLATE: TEMPLATE_SUCCESS,
  MESSAGE: MESSAGE_SUCCESS,
  GENERAL: GENERAL_SUCCESS,
  USER: USER_SUCCESS,
} = SUCCESS_MESSAGES;

export const {
  TEMPLATE: TEMPLATE_CONFIRMATION,
  GENERAL: GENERAL_CONFIRMATION,
} = CONFIRMATION_MESSAGES;
